<template>
    <div class="divs" v-loading.fullscreen.lock="allLoading">
        <div class="divs-c">
            <div class="title">
                <img src="../../assets/logo.png" alt="">
                <h1>{{title}}</h1>
            </div>
            <div class="content">
                <div v-if="isUpgrade" class="upgrade">
                    <img src="../../assets/Upgrade.png" alt="">
                    <h1>网站升级维护中...</h1>
                    <h4>网站正在升级维护中，请稍后再试！</h4>
                </div>
                <div v-for="item in ksArray" :key='item' v-else>
                    <div class="ks" v-show="urlPrefix != 'tengzhou'">{{item}}</div>
                    <div class="list">
                        <div class="list-detail" v-for="items in tableData" :key="items" @click="goDiv(items)">
                            <div v-if="specialArr.indexOf(query.code) != -1 && tableData.find(e=>e.customKind)">
                                <div class="detail-c" v-if="item == items.customKind">
                                    <div class="left">{{items.name}}</div>
                                    <div class="right">查看</div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="detail-c" v-if="item == items.ksName">
                                    <div class="left">{{items.name}}</div>
                                    <div class="right">查看</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { publicDivs, getPublic } from '@/api/public.js'
    export default {
        name: "index",
        data() {
            return {
                allLoading: false,
                tableData: [],
                query: {
                    code: '',
                    year: '',
                    type: '',
                },
                title: '',
                ksArray: [],
                urlPrefix:'',
                openType: this.$store.state.openType == 'js' ? '决算' : '预算',
                isUpgrade:false,
                specialArr:['decheng','pingyuan','laoling','lingcheng','xiajin','linyi']
            };
        },
        async created() {
            let host = window.location.host;
            this.urlPrefix = host.slice(0, host.indexOf("."))
            let prefix = host.split(".")[1];
            this.query.code = host.split(".")[0]
            this.query.year = '20' + prefix.substring(0, 2);
            this.query.type = prefix.substring(2, 4)
            await this.getDivsList();
        },
        methods: {
            goDiv(row) {
                this.$router.push({ name: "公开页面子页面", query: { id: row.id } });
            },
            async getDivsList() {
                let publicRes = await getPublic(this.query)
                if (publicRes.status == '9aa5e47366e74320a934e8ea8124db98') {
                    this.title = `${this.query.year}年部门${this.openType}公开`
                    this.isUpgrade = true
                } else {
                    this.allLoading = true;
                    if (publicRes.status == 0) {
                        this.title = `${publicRes.name}${this.query.year}年部门${this.openType}公开`
                    }
                    let res = await publicDivs(this.query);
                    if (res.status == 0) {
                        if (this.specialArr.indexOf(this.query.code) != -1 && res.divs.find(e=>e.customKind)) {
                            res.divs.forEach(ele => {
                                if (ele.customKind) {
                                    this.ksArray.push(ele.customKind)
                                }
                            })
                        } else {
                            res.divs.forEach(ele => {
                                this.ksArray.push(ele.ksName)
                            })
                        }
                        this.ksArray = Array.from(new Set(this.ksArray))
                        let obj = {};
                        this.ksArray.forEach((item, index) => { //把行政政法科提至最前
                            if (item === '行政政法科') {
                                obj = item;
                                this.ksArray.splice(index, 1)
                                return;
                            }
                        })
                        if (obj.length) {
                            this.ksArray.unshift(obj);
                        }
                        this.tableData = res.divs.filter(ele => ele.type == 2)
                        if (this.tableData.length == 0) {
                            this.$message.info('暂无单位公开!')
                        }
                        this.$nextTick(() => {
                            document.getElementsByClassName('list-detail').forEach(ele => {
                                if (ele.innerText.length == 0) {
                                    ele.style.display = 'none'
                                }
                            })
                        })
                        this.allLoading = false;
                    }
                    this.allLoading = false;
                } 
            },
        },
    };
</script>
<style scoped>
    .divs {
        background: url(../../assets/bg.png) no-repeat center;
        height: 100%;
        width: 100%;
    }

    .divs-c {
        width: 80%;
        height: 100%;
        margin: 0 auto;
    }

    .title {
        width: 100%;
        height: 15vh;
        display: flex;
        align-items: center;
        padding-left: 10px
    }

        .title h1 {
            color: #fff;
            font-weight: normal;
            font-size: 24px;
        }

    .content {
        width: 80%;
        height: 85vh;
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translate(-50%,0);
        background: #fff;
        overflow: auto;
    }
        .content .upgrade {
            text-align: center;
            color: #333;
            line-height: 2.5em;
        }
        .content .upgrade img {
            height: 300px;
            margin-top: 100px;
        }
        .content .ks {
            color: #BD1A2D;
            background: #F5F5F5;
            height: 46px;
            font-size: 18px;
            line-height: 46px;
        }

            .content .ks:before {
                content: "";
                height: 17px;
                width: 3px;
                background: #bd1a2d;
                margin: 15px 7px 0 10px;
                float: left;
            }

        .content .list {
            display: flex;
            flex-wrap: wrap;
        }

    .list-detail {
        width: 33.2%;
        float: left;
        height: 46px;
        line-height: 46px;
        border-right: 1px dashed #e8e8ef;
        border-bottom: 1px dashed #e8e8ef;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

        .list-detail:hover {
            color: #BD1A2D;
            cursor: pointer;
        }

        .list-detail .right:hover {
            cursor: pointer;
            color: #fff;
            background: #2D8CC3;
        }

        .list-detail .detail-c {
            display: flex;
        }

    .detail-c .left {
        padding: 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%
    }

    .detail-c .right {
        height: 46px;
        width: 50px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #2D8CC3
    }
</style>